
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { __assign } from '../../../../../tslib/tslib.es6.mjs.js';
import { useMemo } from 'react';
import { copyRawValuesOnly } from '../html/use-props.mjs.js';
import { buildSVGAttrs } from './utils/build-attrs.mjs.js';
import { createSvgRenderState } from './utils/create-render-state.mjs.js';

function useSVGProps(props, visualState) {
    var visualProps = useMemo(function () {
        var state = createSvgRenderState();
        buildSVGAttrs(state, visualState, { enableHardwareAcceleration: false }, props.transformTemplate);
        return __assign(__assign({}, state.attrs), { style: __assign({}, state.style) });
    }, [visualState]);
    if (props.style) {
        var rawStyles = {};
        copyRawValuesOnly(rawStyles, props.style, props);
        visualProps.style = __assign(__assign({}, rawStyles), visualProps.style);
    }
    return visualProps;
}

export { useSVGProps };
//# sourceMappingURL=use-props.mjs.js.map
